import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import CSSBuyArticle from "@/pages/cssbuy-article/page";
import SuperbuyArticle from "@/pages/superbuy-article/page";
import OopbuyArticle from "@/pages/oopbuy-article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul-kakobuy-poradnik",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CSSBuyArticle />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SuperbuyArticle />,
  },
  {
    path: "/oopbuy-spreadsheet",
    element: <OopbuyArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;